// Get all tabs and tab contents
const productV2Tabs = document.querySelectorAll(".product-v2-tab");
const productV2TabContents = document.querySelectorAll(".product-v2-tab-content");

productV2Tabs.forEach((tab) => {
  tab.addEventListener("click", () => {
    productV2Tabs.forEach((t) => t.classList.remove("product-v2-active"));
    productV2TabContents.forEach((content) => {
      content.classList.remove("product-v2-active");
    });

    tab.classList.add("product-v2-active");
    const tabId = tab.getAttribute("data-tab");
    document.getElementById(tabId).classList.add("product-v2-active");

    // Scroll within the container only — no page movement
    const container = document.getElementById("productV2TabsContainer");
    const tabLeft = tab.offsetLeft;
    const tabWidth = tab.offsetWidth;
    const containerWidth = container.offsetWidth;
    container.scrollTo({
      left: tabLeft - (containerWidth / 2) + (tabWidth / 2),
      behavior: "smooth"
    });
  });
});


// Get all tabs and tab contents
const productV2Tabs2 = document.querySelectorAll(".product-v2-tab-2");
const productV2TabContents2 = document.querySelectorAll(".product-v2-tab-content-2");

productV2Tabs2.forEach((tab) => {
  tab.addEventListener("click", () => {
    productV2Tabs2.forEach((t) => t.classList.remove("product-v2-active-2"));
    productV2TabContents2.forEach((content) => {
      content.classList.remove("product-v2-active-2");
    });

    tab.classList.add("product-v2-active-2");
    const tabId = tab.getAttribute("data-tab");
    document.getElementById(tabId).classList.add("product-v2-active-2");

    // Scroll within the container only — no page movement
    const container = tab.closest(".product-v2-tabs");
    const tabLeft = tab.offsetLeft;
    const tabWidth = tab.offsetWidth;
    const containerWidth = container.offsetWidth;
    container.scrollTo({
      left: tabLeft - (containerWidth / 2) + (tabWidth / 2),
      behavior: "smooth"
    });
  });
});






// // Get all tabs and tab contents
// const productV2Tabs = document.querySelectorAll(".product-v2-tab");
// const productV2TabContents = document.querySelectorAll(".product-v2-tab-content");

// // Listen for clicks
// productV2Tabs.forEach((tab) => {
//   tab.addEventListener("click", () => {
//     // 1) Remove .product-v2-active from all tabs & contents
//     productV2Tabs.forEach((t) => t.classList.remove("product-v2-active"));
//     productV2TabContents.forEach((content) => {
//       content.classList.remove("product-v2-active");
//     });

//     // 2) Mark the clicked tab/content as active
//     tab.classList.add("product-v2-active");
//     const tabId = tab.getAttribute("data-tab");
//     document.getElementById(tabId).classList.add("product-v2-active");

//     // 3) Scroll the clicked tab into view
//     tab.scrollIntoView({
//       behavior: "smooth",
//       block: "nearest", // Avoid vertical scrolling
//       inline: "start"   // Align the tab at the left edge
//     });
//   });
// });








// // Get all tabs and tab contents
// const productV2Tabs2 = document.querySelectorAll(".product-v2-tab-2");
// const productV2TabContents2 = document.querySelectorAll(".product-v2-tab-content-2");

// // Listen for clicks
// productV2Tabs2.forEach((tab) => {
//   tab.addEventListener("click", () => {
//     // 1) Remove .product-v2-active from all tabs & contents
//     productV2Tabs2.forEach((t) => t.classList.remove("product-v2-active-2"));
//     productV2TabContents2.forEach((content) => {
//       content.classList.remove("product-v2-active-2");
//     });

//     // 2) Mark the clicked tab/content as active
//     tab.classList.add("product-v2-active-2");
//     const tabId = tab.getAttribute("data-tab");
//     document.getElementById(tabId).classList.add("product-v2-active-2");

//     // 3) Scroll the clicked tab into view
//     tab.scrollIntoView({
//       behavior: "smooth",
//       block: "nearest", // Avoid vertical scrolling
//       inline: "start"   // Align the tab at the left edge
//     });
//   });
// });


// {/* <script>
//   function switchTab(index, btn) {
//     document.querySelectorAll('.tab-btn').forEach(b => b.classList.remove('active'));
//     btn.classList.add('active');
//     document.querySelectorAll('.tab-panel').forEach(p => p.classList.remove('active'));
//     document.getElementById('panel-' + index).classList.add('active');
//   }
// </script> */}